import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import pt from '../lang/pt.json'
import es from '../lang/es.json'

Vue.use(VueI18n)

const messages = { pt, es }

const savedLocale = Cookies.get('locale')
const defaultLocale = process.env.MIX_LOCALE || 'pt'

export const i18n = new VueI18n({
  locale: savedLocale || defaultLocale,
  fallbackLocale: 'pt',
  messages,
})

/* <html lang> acompanha o idioma da interface: leitores de tela escolhem a
   voz por ele. O Blade entrega pt-BR; aqui ele vira o idioma real no boot e
   em qualquer troca ($i18n.locale é reativo — LanguageMenu, LoginApp e
   AdminApp o alteram). */
const htmlLang = { pt: 'pt-BR', es: 'es' }
new Vue().$watch(
  () => i18n.locale,
  (locale) => {
    document.documentElement.lang = htmlLang[locale] || locale
  },
  { immediate: true }
)

export default i18n